import BrandingSegmentationDirective from './BrandingSegmentationDirective';
import BrandingData from 'gw-portals-branding-js/BrandingData';

export default angular.module('edge.platform.segmentation.branding', []).value('brandingData', BrandingData.BRANDING).directive('gwBrandingSegmentation', BrandingSegmentationDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/branding/module.js
// module id = 1064
// module chunks = 0